import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import AlertCircle from "@insite/mobius/Icons/AlertCircle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    showIcon = "showIcon",
    richContentField = "richContentField",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showIcon]: boolean;
        [fields.richContentField]: string;
    };
}

export interface HeaderTopTextStyles {
    wrapper: InjectableCss;
    contentWrapper: InjectableCss;
    iconStyles: IconPresentationProps;
}

const headerTopTextStyles: HeaderTopTextStyles = {
    wrapper: {
        css: css`
        background-color: #f5f5f5;
        padding: 5px;`,
    },
    contentWrapper: {
        css: css`
        max-width: 1440px;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        p, h1, h2, h3, h4, h5 {
            margin-bottom: 0;
        }
        text-align: center;`,
    },
    iconStyles: {
        css: css`
            padding-right: 10px;`,
    },
};

type Props = OwnProps;

const InformationBar: React.FC<Props> = ({ fields }) => {
    return <StyledWrapper {...headerTopTextStyles.wrapper}>
        <StyledWrapper {...headerTopTextStyles.contentWrapper}>{
            fields.showIcon && <Icon {...headerTopTextStyles.iconStyles} src={AlertCircle} color="warning.main"></Icon>
        }
            <>{parse(fields.richContentField, parserOptions)}</>
        </StyledWrapper>
    </StyledWrapper>;
};

const widgetModule: WidgetModule = {
    component: InformationBar,
    definition: {
        group: "Header",
        icon: "Link",
        fieldDefinitions: [
            {
                name: fields.showIcon,
                displayName: "Show Icon",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                isRequired: true,
                variant: "toggle",
            },
            {
                name: fields.richContentField,
                displayName: "Description",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "General",
                placeholder: "Enter text",
                isRequired: false,
            },
        ],
    },
};

export default widgetModule;
